import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import ProductsOfferings from '../components/home/ProductsOfferings';
import { organizationSchema, webPageSchema } from '../seo/schema';

const ProductsPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('productsPage.seoTitle');
  const description = t('productsPage.seoDescription');

  return (
    <>
      <SEO
        title={title}
        description={description}
        url="https://simpian.com/products"
        jsonLd={[organizationSchema, webPageSchema(title, description, '/products')]}
      />
      <ProductsOfferings id="products" asPage />
    </>
  );
};

export default ProductsPage;
